import { render, staticRenderFns } from "./Exibir.vue?vue&type=template&id=7b913baf&scoped=true&"
import script from "./Exibir.vue?vue&type=script&lang=js&"
export * from "./Exibir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b913baf",
  null
  
)

export default component.exports